import "./brokerConvenienceConfirmationAltFundsSuccess.scss";

// @vendors
import React from "react";
import PropTypes from "prop-types";

// @commons
const { OKButton } = require("components/commons/OKButton/OKButton");
const { OKMessage } = require("commonsComponents/OKMessage");

// @utilities
const { FormattedText } = require("core/i18n").i18n;
const { buildTestScoreInfoForAltFunds } = require("mifid/utilities/mifidTestTextHelper");

// @constant
const { BROKER_PG_URL } = require('constants/index');

class BrokerConvenienceConfirmationAltFundsSuccess extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { immBrokerConvenienceMiFIDTest } =  this.props;
        const immMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidv2');
        const result = immMifidv2.get('result');

        const customData = {
            nombrePagina: "tu-inviertes/test-mifid",
            tipoProceso: "proc-tu-inviertes-test-mifid",
            pasoProceso: "exito",
            detalleProceso: result === 'A' ? "idoneo" : "no idoneo"
        }

        window &&
            window.utag &&
            window.utag.view &&
            window.utag.view(customData);
    }

    render() {
        const { immBrokerConvenienceMiFIDTest, history } =  this.props;
        const immMifidv2 = immBrokerConvenienceMiFIDTest.get('mifidv2');
        const result = immMifidv2.get('result');

        const titleIcon = result === 'A' ? (
            <div className="convenience-alternative-funds-test-success__details-icon-success" />
        ): (
            <div className="convenience-alternative-funds-test-success__details-icon-fail-container">
                <i className="convenience-alternative-funds-test-success__details-icon-fail icon-cerrar" />
            </div>
        );

        const disaprovedDisclaimer = result !== 'A' ? (
            <div className="convenience-alternative-funds-test-success__info-text">
                <OKMessage type={"informative"}>
                    <div className="ra-goal-notification__info">
                        <FormattedText value="broker-convenienceMifidAltFundsSuccessDisclaimer"
                            injectedStrings={[immMifidv2.get('expirationYears')]}
                        />
                    </div>
                </OKMessage>
            </div>
        ) : null;

        const finishButton =
            result !== "A" ? (
                <OKButton
                    modifier="secondary"
                    onClick={() => history.push(BROKER_PG_URL)}
                    className="convenience-alternative-funds-test-success__details-footer-button-fail"
                >
                    <FormattedText value="broker-convenienceMifidAltFundsSuccessGoToMyInvestmentsCTA" />
                </OKButton>
            ) : (
                <div  className="convenience-alternative-funds-test-success__details-footer-button-success">
                    <OKButton
                        onClick={this.props.goToFinishTest}
                        modifier="primary"
                    >
                        <FormattedText value="broker-convenienceMifidAltFundsSuccessContinueCTA" />
                    </OKButton>
                </div>
            );

        return (
            <React.Fragment>
                <div className="convenience-alternative-funds-test-success__top-disclaimer no-print-out">
                    <FormattedText value="broker-convenienceMifidAltFundsSuccessHeaderTitle"/>
                </div>
                <div className="convenience-alternative-funds-test-success__profile-section">
                    <div className="convenience-alternative-funds-test-success__details-header">
                        {titleIcon}
                        <h3 className="convenience-alternative-funds-test-success__details-title">
                            <FormattedText value="broker-convenienceMifidAltFundsSuccessTitle"/>
                        </h3>
                    </div>
                    <div className="convenience-alternative-funds-test-success__details-body">
                        <div className="convenience-alternative-funds-test-success__details-separator"/>
                        <div className="convenience-alternative-funds-test-success__details-body-title">
                            <FormattedText value="broker-convenienceMifidSuccessDetailTitle"/>
                        </div>
                        <div className="convenience-alternative-funds-test-success__details-body-result">
                            {buildTestScoreInfoForAltFunds(result)}
                        </div>
                    </div>
                    {disaprovedDisclaimer}
                    <div className="convenience-alternative-funds-test-success__details-footer">
                        {finishButton}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
BrokerConvenienceConfirmationAltFundsSuccess.propTypes = {
    goToFinishTest: PropTypes.func,
    title: PropTypes.string,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
    history: PropTypes.object,
}

module.exports = BrokerConvenienceConfirmationAltFundsSuccess;
